//  Libraries
import React from 'react';
import PropTypes from 'prop-types';
import config from 'config';
import { Button, Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import * as mixpanelTracker from 'app-lib/mixpanel/mixpanelTracker';

const classPrefix = 'signin-modal';

export class SignInModal extends React.Component {
    constructor(props) {
        super(props);
    }
    close() {
        this.props.close();
    }

    socialLogin(loginType) {
        const baseUrl = window.location.href.split('?')[0];
        const queryStr = window.location.href.split('?')[1];

        let target = window.location.href;

        if (loginType === 'corporate') {
            mixpanelTracker.track(`${mixpanelTracker.signInModalClicked}-${mixpanelTracker.valueCorporate}`);
            target = `${baseUrl}?login=corporate&tos=true`;
        } else if (loginType === 'facebook') {
            mixpanelTracker.track(`${mixpanelTracker.signInModalClicked}-${mixpanelTracker.valueFacebook}`);
            target = `${baseUrl}?login=facebook&tos=true`;
        } else if (loginType === 'linkedin') {
            mixpanelTracker.track(`${mixpanelTracker.signInModalClicked}-${mixpanelTracker.valueLinkedin}`);
            target = `${baseUrl}?login=linkedin&tos=true`;
        } else if (loginType === 'google') {
            mixpanelTracker.track(`${mixpanelTracker.signInModalClicked}-${mixpanelTracker.valueGooglePlus}`);
            target = `${baseUrl}?login=google&tos=true`;
        }

        target = (queryStr) ? `${target}&${queryStr}` : target;

        window.location.href = target;
    }

    getLoginOptions() {
        const {t} = this.props;
        return (
            <div className={`${classPrefix}-socialLogin`}>
                <Button className="gotowebinar-btn" onClick={this.socialLogin.bind(this, 'corporate')}>
                    <div className="gotowebinar-icon float-left">
                        <i className="togo-icon togo-icon-gotomeeting togo-icon-2x "></i>
                    </div>
                    <div className="text">{t('signinModal.gotowebinar')}</div>
                </Button>
                <Button className="linkedin-btn" onClick={this.socialLogin.bind(this, 'linkedin')}>
                    <img src={`${config.assets.url}/images/watch-now/registration-modal/linkedIn.png`} alt="" />
                    <div className="text">{t('signinModal.linkedin')}</div>
                </Button>
                <Button className="facebook-btn" onClick={this.socialLogin.bind(this, 'facebook')}>
                    <img src={`${config.assets.url}/images/watch-now/registration-modal/facebook.png`} alt="" />
                    <div className="text">{t('signinModal.facebook')}</div>
                </Button>
                <Button className="google-btn" onClick={this.socialLogin.bind(this, 'google')}>
                    <img src={`${config.assets.url}/images/watch-now/registration-modal/google.png`} alt="" />
                    <div className="text">{t('signinModal.google')}</div>
                </Button>
            </div>
        );
    }

    getRegistrationTerms() {
        const {t} = this.props;
        return (
            <div className={`${classPrefix}-terms`}>
                {t('registrationModal.register-terms-1a')}
                <a href={`${config.company.privacyPolicy}`} target="_blank" rel="noopener">{t('registrationModal.register-terms-1b')}</a>
                {t('registrationModal.register-terms-1c')}
                <a href={`${config.company.termsOfService}`} target="_blank" rel="noopener">{t('registrationModal.register-terms-1d')}</a>
                {t('registrationModal.register-terms-1e')}
            </div>
      );
    }

    render() {
        const {t} = this.props;
        return (
            <Modal dialogClassName="signin-modal-dialog" show={this.props.show} onHide={this.close.bind(this)}>
                <Modal.Header closeButton>
                    <div>
                        <div><img alt="GoToStage.com Logo" src={`${config.assets.url}/images/shared-components/nav-bar/g2stage-logo-black.svg`} /></div>
                        <div className="signin__sub-heading">{t('signinModal.header')}</div>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    {this.getLoginOptions()}
                </Modal.Body>
                <Modal.Footer>
                    <hr className="signin__separator" />
                    {this.getRegistrationTerms()}
                </Modal.Footer>
            </Modal>
        );
    }
}

SignInModal.propTypes = {
    show: PropTypes.bool,
    close: PropTypes.func,
    t: PropTypes.func.isRequired
};

export default translate(['translation'])(SignInModal);



// WEBPACK FOOTER //
// ./src/components/SharedComponents/modal/signin-modal.js